module.exports = __webpack_public_path__ + "img/college8.810393b5.png";